// @format
const environment = process.env.NODE_ENV || 'localhost';

const settings = {
  default: {
    environment,
    baseUrl: process.env.VUE_APP_BASE_URL || 'http://localhost:5000',
    server: {
      apiServer: process.env.VUE_APP_API_URL || 'http://localhost:8888',
      /* eslint-disable-next-line max-len */
      secret: 'HrIK5Q1Ih8jcxrJbzesi3zmwy9fXBE0Tt0mY96fGu2Ph+RnZWm33zEKt3EB+q7MBR1F9ONpbhQtB9hjGklYBtMGAvlqMKGqIPBv+jpk7EKTzzPBxcvwF32OHagAAq8Mh/iUiSI2kjd4EOMIJ3xNCvMk406ihl+B+As8EAMuL3sPLHWI32uDuA1H9KCpswUpb1S4vwxEHiwSuUOCgMe0mZPjPzrvbduKLctumzdEGYuiqP9EYYgdqXKVVY9AfRT7YtpEs7Uj1MLtV9lWgEuo1Ibrqr26eDgAPW4LJwMaLfZxHtEmBqIxNkY0KCcs9OgYo7nno0aH1CDzG3SSZbssmDw==',
      cookie: {
        encoding: 'none',
        isSecure: environment === 'production',
        path: '/',
        isSameSite: 'Strict',
        isHttpOnly: false,
        clearInvalid: false,
        ignoreErrors: true,
      },
    },
    twitter: {
      provider: 'twitter',
      password: '=TwjgYeAn7xuWZFatA7s4ArXegZnX2Rb',
      clientId: 'HPsdirbO6FTfsGEhCXtAGg',
      clientSecret: '0EA2LXSkSOhAni1x4jfqidUsm1SvBNnlEBS3ObpAJPs',
      isSecure: false,
    },
    facebook: {
      provider: 'facebook',
      password: '=TwjgYeAn7xuWZFatA7s4ArXegZnX2Rb',
      scope: ['email'],
      config: {
        fields: ['name'],
      },
      // appId: '1508901472719008',
      // clientId: "5746473025266e2426743a727f7621b0",
      clientId: '1508901472719008',
      clientSecret: 'd3b17bcc3f2e7c4c82ee4d857385a808',
      isSecure: environment === 'production',
    },
    google: {
      key: 'AIzaSyDgNB0yaDNBIsvwyXOGQsNeth0Tu9LLKH0',
      country: 'uk',
    },
  },
  localhost: {},
  production: {
    twitter: {
      provider: 'twitter',
      password: '=TwjgYeAn7xuWZFatA7s4ArXegZnX2Rb',
      clientId: 'iXsJYxUydQJy9iYuVKw',
      clientSecret: 'GdaPcyNdtFoCoHHBxDOyTI6NOoJyMwWadlHXZpxA4ak',
      isSecure: true,
      forceHttps: true,
    },
  },
};

module.exports = Object.assign(settings.default, settings[environment]);
